import user from './modules/user' // 03  用户中心
import attendanceStatistics from './modules/attendanceStatistics' // 考勤统计
import beddingStatistic from './modules/beddingStatistics' // 03  归寝统计
import accommodationManagement from './modules/accommodationManagement'
import systemConfig from './modules/systemConfig' // 系统配置
import sanitationManage from './modules/sanitationManage';
import accessManage from './modules/accessManage';

export const home = {
    path: '/sggk',
    menuName: '首页',
    // component: require('@/pages/home/index'),
    component: (resolve) => require(['@/pages/home/index'], resolve),
}

export default [{
    path: '/',
    seqenceNum: -1,
    redirect: to => {
        return '/sggk'
    },
    component: (resolve) => require(['@/pages/index.vue'], resolve),
    children: [
		home,
		user,
		attendanceStatistics,
		beddingStatistic,
		accommodationManagement,
        systemConfig,
        sanitationManage,
        accessManage
	]
}]



// WEBPACK FOOTER //
// ./src/routes/route_map.js